export const BRAND_ERROR_PATH_MATCHER = "*brand-error*";
export const BRAND_UNAVAILABLE_PATH_MATCHER = "*brand-unavailable*";
export const SEARCH_PAGE_PATH_MATCHER = "*/search/*";
export const BRANDS_PAGE_PATH_MATCHER = "*/a-to-z-of-brands/cat/";
export const CATEGORY_PAGE_PATH_MATCHER = "*/cat/";
export const PAGE_NOT_FOUND_PATH_MATCHER = "*";
